<template>
  <div class="container plotter bottom">
    <div class="header bottom-shadow">

      <label v-show="lengthText === 'Start plotting by clicking the map'">{{lengthText}}</label>
      <div v-show="lengthText !== 'Start plotting by clicking the map'" style="display:flex;flex-direction:column;">
      <label>{{lengthText}}</label>
      <label v-on:click="switchUnit()" class="km-mi-switch">{{switchUnitText}}</label>

      </div>
      <label class="add-event-text" v-show="showAdminContent">Add Event from GPX file</label>

    </div>

    <div class="inputs" style="margin-left:50px; margin-right:50px;">
          <div class="input-container">
            <input name="name" type="text" v-model="routeName" placeholder="Route Name">
          </div>
        </div>

    <div class="bottom-container">
        <div class="loader" style="padding:20px" v-bind:class="{ 'loader-hide' : plotUpload.state != 2 }"></div>

<div class="editPath-buttons" v-show="plotUpload.state !== 2">
              <div class="editPath-button" ng-style="routingWayPoints >= 3 && {} || {'filter':'grayscale(100)'}">
                  <!--<img src="../img/plotter/undo_last.svg">-->
                  <img class="opacityThreeQ pointer" v-on:click="undo()" src="../img/plotter/ic_pathbar_undo.svg" width="44px" height="44px">
                  <label>Undo last</label>
              </div>

              <div class="editPath-button" v-if="followPathsBoolean">
                  <img class="opacityThreeQ pointer" v-on:click="followPaths()" src="../img/plotter/ic_pathbar_followroads_on.svg" width="44px" height="44px">
                  <label>Follow roads</label>
              </div>
              <div class="editPath-button" v-if="!followPathsBoolean">
                  <img class="opacityThreeQ pointer" v-on:click="followPaths()" src="../img/plotter/ic_pathbar_followroads_off.svg" width="44px" height="44px">
                  <label>Follow roads</label>
              </div>
              <div class="editPath-button">
                    <img class="opacityThreeQ pointer" v-on:click="clearAll()" src="../img/plotter/clear_all.svg" width="44px" height="44px">
                    <label>Clear all</label>
                </div>

            </div>    </div>

    <BottomNav @previousPage="previousPage()" @nextPage="nextPage()" pText="Back" v-bind:pColor="pColor" nText="Create" v-bind:nColor="nextButtonColor"/>

  </div>
</template>

<script>

  import firebase from 'firebase'
  import BottomNav from './BottomNav'
  import { mapFields } from 'vuex-map-fields'
  import { store } from '../store/store'
  import MapManager from '../helpers/mapManager'
  import moment from 'moment'
  import { userRef } from '../firebase'
  import axios from 'axios'

  export default {
    name: 'gpxImport',
    title: 'Runner - Gpx Import',
    data() {
      return {
        plotUpload: {
          state: 0,
          length: 0,
          previewUrl: '',
          routeId: '',
          error: false
        },
        pColor: 'yellow',
        nColor: 'gray',
        nColor2: 'green',
        filename: 'Choose a file...',
        lengthText: 'Start plotting by clicking the map',
        followPathsBoolean: true,
        routeName: '',
        isMiles: false
      }
    },
    components: {
       BottomNav
    },
    computed: {
      isDisabled() {
        return this.plotUpload.state != 2 ? false : true
      },
      switchUnitText() {
        if (this.isMiles) {
          return 'Show in kilometers'
        } else {
          return 'Show in miles'
        }
      },
      nextButtonColor() {
        if (this.routeName === '') {
          return 'gray'
        } else {
        return 'green'
        }
      }
    },
    mounted() {
    MapManager.startPlotting()

    window.addEventListener('plotter-length', e => {
      this.lengthText = MapManager.getLengthString(this.isMiles)
    }, false)
    },
    asyncComputed: {
      showAdminContent() {
        return new Promise((resolve, reject) => {
          firebase.auth().currentUser.getIdTokenResult()
          .then((idTokenResult) => {
            // Confirm the user is an Admin.
            if (idTokenResult.claims.admin && this.$route.params.addEvent) {
             resolve(true)
           } else {
             resolve(false)
           }
          })
          .catch((error) => {
            console.log(error)
            resolve(false)
          })
        })
      }
    },
    methods: {
      gpxImport() {
        console.log("import")

          this.plotUpload.error = false
          this.nColor = 'gray'

              this.plotUpload.preview_img = '';
              this.plotUpload.state = 2;

              var routeId = 'new'

              firebase.auth().currentUser.getIdToken().then((token) => {

                var files = document.getElementById('gpxFile');
                var file = files.files[0];

                let date = moment().format("MM/DD/YYYY HH:MM")

                var formData = new FormData();
                formData.append("route-id", routeId);
                formData.append("gpx", file);
                formData.append("raceGpx", true);
                //formData.append("timestamp", moment().utc("MM/DD/YYYY HH:MM").valueOf() / 1000)
                var xhr = new XMLHttpRequest();

                xhr.open("POST", "https://us-central1-racepeps.cloudfunctions.net/api/processPlotted", true);

                xhr.setRequestHeader('Authorization', 'Bearer ' + token);

                xhr.onload = () => {
                    if (xhr.readyState === xhr.DONE) {
                        if (xhr.status === 200) {
                          var result = JSON.parse(xhr.responseText);
                          console.log(result);

                          console.log(this.plotUpload)

                          this.nColor = 'green'

                          this.plotUpload.state = 1;
                          this.plotUpload.length = result.length;
                          this.plotUpload.previewUrl = result.preview_img;
                          this.plotUpload.routeId = result.id;

                        } else {
                          console.log("Failed to process gpx file");
                          this.plotUpload.state = 0;
                          this.plotUpload.error = true;
                        }
                    }
                }

                xhr.onerror = (err) => {
                  console.log("Failed to process gpx file");
                  this.plotUpload.state = 0;
                  this.plotUpload.error = true;
                };

                xhr.send(formData);

            });

          },
          uploadPlot() {
          let coordinatesLength = MapManager.getRoutingCoordinatesLength()
          if (coordinatesLength >= 2) {
          let encoded = MapManager.getPlottedRouteEncoded()
          let name = this.routeName
          console.log(name)
          let data = { encoded: encoded, name: name }

          this.plotUpload.error = false
          this.nColor = 'gray'

              this.plotUpload.preview_img = '';
              this.plotUpload.state = 2;

              firebase.auth().currentUser.getIdToken().then((token) => {
                const config = {
                  headers: { Authorization: `Bearer ${token}` }
                }

                axios.post('https://us-central1-racepeps.cloudfunctions.net/api/processPlotted', data, config).then(response => {
                let result = response.data
                  this.nColor = 'green'
                  this.plotUpload.state = 1;
                  this.plotUpload.length = result.length;
                  this.plotUpload.previewUrl = result.preview_img;
                  this.plotUpload.routeId = result.id;
                  this.uploadCompleted()


                })

            });
          }
          },
      undo() {
            MapManager.undo()
      },
      followPaths() {
        MapManager.followPaths()
        this.changeFollowPathsBoolean()

      },
      clearAll() {
        MapManager.clearAll()
      },
      changeFollowPathsBoolean() {
        this.followPathsBoolean = !this.followPathsBoolean
      },
      previousPage() {
        MapManager.clearAll()
        MapManager.disableInteraction()
        MapManager.endPlotting()
        this.lengthText = 'Start plotting by clicking the map'
        window.removeEventListener('plotter-length', {})

        console.log("cancel")
        if(this.plotUpload.state != 2) {

          if (this.plotUpload.routeId != '') {
            console.log("was not empty route")

            this.$store.dispatch('removeRace', this.plotUpload.routeId).then(() => {
              console.log("route removed, changing page")
              this.$router.replace('menu')
            })
          } else {
            this.$router.replace('menu')
          }
        }
      },
      gpxFileChanged() {

        var fullPath = document.getElementById('gpxFile').value;
        if (fullPath) {
          var startIndex = (fullPath.indexOf('\\') >= 0 ? fullPath.lastIndexOf('\\') : fullPath.lastIndexOf('/'));
          var filename = fullPath.substring(startIndex);
          if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
            filename = filename.substring(1);
          }
            console.log(filename)
            this.filename = filename
        } else {
          this.filename = "Choose a file..."
        }

        console.log("gpx file changed");

        if (this.plotUpload.routeId != '') {
          console.log("was not empty route")
          console.log(this.plotUpload.routeId)

          this.$store.dispatch('removeRace', this.plotUpload.routeId).then(function() {
            console.log("Race deleted due to change of file")
          })
        }

        this.nColor = 'gray'
        this.plotUpload.state = 0;
        this.plotUpload.length = 0;
        this.plotUpload.previewUrl = '';
        this.plotUpload.routeId = '';

        this.gpxImport()

    },
    nextPage() {
      if (this.routeName === '') {
        alert('Set route name first!')
        return
      }
      window.removeEventListener('plotter-length', {})
      this.uploadPlot()
    },
    uploadCompleted() {
      MapManager.clearAll()
      MapManager.disableInteraction()
      MapManager.endPlotting()

      if(this.plotUpload.state === 1) {
        console.log("nextPage")
        this.$router.replace('myraces')
      }
    },
    switchUnit() {
      this.isMiles = !this.isMiles
      this.lengthText = MapManager.getLengthString(this.isMiles)

    }
  }
}

</script>

<style lang="scss" scoped>

  @import '../styles/styles.scss';

  .mid-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 8;
  }

  .bottom-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 2;

    span {
      padding: 10px;
      font-weight: 700;
      background-color: $cyan;
      color: white;
      cursor: pointer;
    }

  }

  .inputfile {
  	width: 0.1px;
  	height: 0.1px;
  	opacity: 0;
  	overflow: hidden;
  	position: absolute;
  	z-index: -1;
  }

  #gpxError {
    color: red;
    font-size: $font-medium;
    text-align: center;
    padding-right: 50px;
    padding-left: 50px;
    margin-top: 30px;
  }

  @media screen and (min-width: 1140px) {

    .gpxImport {
        width: 460px !important;
        height: 580px !important;
    }

    .plotter {
        width: 460px !important;
        height: 270px !important;
    }
  }

  .big {
  position: absolute;
  bottom: 0;
  width: 100%; }

  .big .top {
	width: 100%;
	//height: 50px;
	height: 65px;
	background-color: white;
	display: flex;
	justify-content: space-between;
  align-items: center;


}

.big-container {
    display: flex;
    justify-content: center;
    width: 100%; }

    .editPath-buttons {
	width: 80%;
	display:flex;
	justify-content:space-around;
	flex-direction:row;
}

.editPath-button {
	display: flex;
	justify-content: space-between;
	flex-direction: column;
	align-items: center;


	label {
		font-size: $font-small;
		opacity: 0.7;
	}
}
.km-mi-switch {
  font-size: $font-semi;
  margin-top:8px;
  color: $black_90;
  cursor: pointer;
  text-decoration: underline;
}

</style>
